import { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { ShieldCheck, AlertCircle, ArrowRight } from "lucide-react";
import { useAdmin } from "../../admin/AdminContext";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function AdminLogin() {
  const { login, status } = useAdmin();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => { document.title = "Admin login — Tip Top Property"; }, []);

  if (status === "authed") {
    return <Navigate to={location.state?.from || "/admin"} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate(location.state?.from || "/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Inloggen mislukt. Controleer je gegevens.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-screen grid place-items-center bg-secondary/30 px-4">
      <div className="w-full max-w-md card-soft p-8" data-testid="admin-login-card">
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.22em] font-bold text-accent">
          <ShieldCheck className="h-3.5 w-3.5" />
          Admin
        </div>
        <h1 className="mt-4 text-3xl tracking-tight font-medium text-foreground">Tip Top — dashboard</h1>
        <p className="mt-2 text-sm text-muted-foreground">Log in om binnenkomende leads te beheren.</p>

        <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <div>
            <Label className="text-xs uppercase tracking-[0.18em] text-muted-foreground">E-mail</Label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@tiptopproperty.eu"
              required
              autoFocus
              data-testid="admin-email"
              className="mt-1.5"
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Wachtwoord</Label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password"
              className="mt-1.5"
            />
          </div>
          {error && (
            <p className="flex items-center gap-1.5 text-xs text-destructive" data-testid="admin-login-error">
              <AlertCircle className="h-3.5 w-3.5" />
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="btn-primary w-full justify-center disabled:opacity-60"
          >
            {loading ? "…" : "Inloggen"}
            <ArrowRight className="h-4 w-4" />
          </button>
        </form>
      </div>
    </section>
  );
}
